var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { id: "hamburger-container", "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar },
      }),
      _c("breadcrumb", {
        staticClass: "breadcrumb-container",
        attrs: { id: "breadcrumb-container" },
      }),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container",
              attrs: { trigger: "click" },
              on: { command: _vm.handleCommand },
            },
            [
              _c("div", { staticClass: "avatar-wrapper" }, [
                _vm.name
                  ? _c("div", { staticClass: "user-title" }, [
                      _vm._v(_vm._s(_vm.name)),
                    ])
                  : _vm._e(),
                _c("img", {
                  staticClass: "user-avatar",
                  attrs: { src: require("@/assets/profile.png") },
                }),
              ]),
              _c(
                "el-dropdown-menu",
                {
                  staticClass: "user-dropdown",
                  attrs: { slot: "dropdown" },
                  slot: "dropdown",
                },
                [
                  _c("el-dropdown-item", { attrs: { command: "profile" } }, [
                    _c("i", { staticClass: "el-icon-user" }),
                    _vm._v(" 个人信息"),
                  ]),
                  _c("el-dropdown-item", { attrs: { command: "password" } }, [
                    _c("i", { staticClass: "el-icon-lock" }),
                    _vm._v(" 修改密码"),
                  ]),
                  _c(
                    "el-dropdown-item",
                    { attrs: { divided: "", command: "logout" } },
                    [
                      _c("i", { staticClass: "el-icon-switch-button" }),
                      _vm._v(" 退出系统"),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }